import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import Markdown from '@Shared/Markdown';
import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

const Notice: React.FC = () => {

  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);

  useEffect(() => {
    api.getNotice();
  }, []);

  const getStatus = () => {
    return store.notice?.substring(0, 9).toUpperCase() == '<H1>ATTN:'
      ? 'danger'
      : 'info';
  }

  return store.notice ? (
    <Row>
      <Col xs={12} style={{ paddingTop: 39 }}>
        <div className={'alert btn-' + getStatus()} style={{ padding: '6px 26px 15px', margin: '0 0 3px' }}>
          <div className='alert-watermark' style={{ fontSize: '200%', textShadow: 'none' }}>
            <span
              className='fas fa-asterisk'
              style={{ fontSize: '600%', left: -20, opacity: .1, position: 'absolute', top: '5%' }}
            />
          </div>
          <Markdown id='notice'>
            {store.notice}
          </Markdown>
        </div>
      </Col>
    </Row>
  ) : null;
}

export default Notice;